$(document).on('change', '#language_code', function() {
  $.post('/set_language', {
    language_code: $('#language_code').val(),
    authenticity_token: $('meta[name="csrf-token"]').attr('content')
  }, function() {
    document.location.reload()
  })
})
